// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/pages/" + chunkId + "." + {"761":"ccd04ed114a566bc8814","3820":"d43fc806f4c020830f71","4474":"edfdc83926e325dae2f3"}[chunkId] + ".js";
};